__turbopack_context__.v({
  "actionIcon": "signedInMenu-module-scss-module__p3jtOq__actionIcon",
  "actionIconSignout": "signedInMenu-module-scss-module__p3jtOq__actionIconSignout",
  "actionLabel": "signedInMenu-module-scss-module__p3jtOq__actionLabel",
  "actionLabelPrimary": "signedInMenu-module-scss-module__p3jtOq__actionLabelPrimary",
  "actionLabelSecondary": "signedInMenu-module-scss-module__p3jtOq__actionLabelSecondary",
  "actionRow": "signedInMenu-module-scss-module__p3jtOq__actionRow",
  "actionRowPrimary": "signedInMenu-module-scss-module__p3jtOq__actionRowPrimary",
  "header": "signedInMenu-module-scss-module__p3jtOq__header",
  "headerAccount": "signedInMenu-module-scss-module__p3jtOq__headerAccount",
  "headerName": "signedInMenu-module-scss-module__p3jtOq__headerName",
  "menu": "signedInMenu-module-scss-module__p3jtOq__menu",
  "section": "signedInMenu-module-scss-module__p3jtOq__section",
  "sections": "signedInMenu-module-scss-module__p3jtOq__sections",
});
